import TipoCentroCostoService from 'src/modules/tipoCentroCosto/tipoCentroCostoService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'TIPOCENTROCOSTO_FORM';

const tipoCentroCostoFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoCentroCostoFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TipoCentroCostoService.find(id);
      }

      dispatch({
        type: tipoCentroCostoFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoCentroCostoFormActions.INIT_ERROR,
      });

      getHistory().push('/tipo-centro-costo');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: tipoCentroCostoFormActions.CREATE_STARTED,
      });

      await TipoCentroCostoService.create(values);

      dispatch({
        type: tipoCentroCostoFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoCentroCosto.create.success'),
      );

      getHistory().push('/tipo-centro-costo');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoCentroCostoFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: tipoCentroCostoFormActions.UPDATE_STARTED,
      });

      await TipoCentroCostoService.update(id, values);

      dispatch({
        type: tipoCentroCostoFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.tipoCentroCosto.update.success'),
      );

      getHistory().push('/tipo-centro-costo');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoCentroCostoFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default tipoCentroCostoFormActions;
